// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cf870927","732":"a67db69f","977":"cd8b5d38"}[chunkId] + ".chunk.js";
};